import React from 'react';
import '../../css/BdStyles.css';

const BdUserPage = () => {
  return (
    <div className="bd">
    <div>
      <h1>Acceso permitido</h1>
      <h4>Saludos, ya puedes insertar y modificar registros.
      Las propuestas serán enviadas al equipo de revisión para su evaluación.</h4>
    </div>
    </div>
  );
};

export default BdUserPage;